import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_PROFESSIONNELS } from '../../../../config/aides-professionnels';

export default function OptimisationTurpePage() {
  const aide = AIDES_PROFESSIONNELS.find((a) => a.slug === 'optimisation-turpe');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="professionnels" />;
}
